import { Component, Inject, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Response } from '@angular/http';
import { NgForm, FormControl } from '@angular/forms';

import { Cliente } from '../cliente.model';
import { NavigationService } from '../../shared-services/navigation.service';
import { Telefono } from '../../security/user/telefono.model';
import { Email } from '../../security/user/email.model';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { EstadoCliente } from '../estadoCliente.model';
import { OperationalParametric } from '../operationalParametric.model';
import { Direccion } from '../direccion.model';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { PaisCliente } from '../paisCliente.model';
import { TelefonoCliente } from '../telefonoCliente.model';
import { EmailCliente } from '../emailCliente.model';
import { Documento } from '../documento.model';
import { MontoCompra } from '../montoCompra.model';
import { OperationalDepartamento } from '../operationalDepartamento.model';
import { OperationalProvincia } from '../operationalProvincia.model';
import { Documentacion } from '../documentacion.model';
import { ClienteService } from '../../core/cliente.service';
import { Logo } from '../logo.model';

@Component({
  selector: 'app-cliente-add-edit',
  templateUrl: './cliente-add-edit.component.html',
  styleUrls: ['./cliente-add-edit.component.scss']
})
export class ClienteAddEditComponent implements OnInit {
  @ViewChild('clienteForm') public clienteForm: NgForm;

  private hash: string;
  cliente: Cliente;
  private documentacionRespaldatoria: Documentacion[];
  validationFail = false;
  emailPrincipalFail = false;
  private montoCompraFail = false;
  private montoCompraTipoMonedaFail = false;
  EstadoCliente = new EstadoCliente();
  PaisCliente = new PaisCliente();
  private TelefonoCliente = new TelefonoCliente();
  private EmailCliente = new EmailCliente();
  selected = new FormControl(0);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private snackService: SnackService,
    private backendService: BackendService,
    private dialogService: DialogService,
    clienteService: ClienteService,
    private formValidatorService: FormValidatorService
  ) { }

  ngOnInit() {

    this.route.data.subscribe(data => {
      this.cliente = data.cliente;
      this.cliente.nacionalidad = this.cliente.nacionalidad ? this.cliente.nacionalidad : new OperationalParametric();
      this.cliente.emisorDocumento = this.cliente.emisorDocumento ? this.cliente.emisorDocumento : new OperationalParametric();
      this.cliente.tipoDocumento = this.cliente.tipoDocumento ? this.cliente.tipoDocumento : new OperationalParametric();
      this.cliente.situacionIva = this.cliente.situacionIva ? this.cliente.situacionIva : new OperationalParametric();
      this.cliente.montoCompraActual = this.cliente.montoCompraActual ? this.cliente.montoCompraActual : new MontoCompra();
      this.cliente.documentacionPendiente = this.cliente.documentacionPendiente ? this.cliente.documentacionPendiente : false;
      this.cliente.personaPoliticamenteExpuesta =
        this.cliente.personaPoliticamenteExpuesta ? this.cliente.personaPoliticamenteExpuesta : false;
      if (!this.cliente.genero) {
        this.cliente.genero = this.cliente.genero ? this.cliente.genero : new OperationalParametric();
        this.cliente.genero.id = 1;
      }
      if (!this.cliente.estado) {
        this.cliente.estado = this.cliente.estado ? this.cliente.estado : new OperationalParametric();
        this.cliente.estado.id = this.EstadoCliente.staticPendAprobacion;
      }
      if (!this.cliente.direcciones || this.cliente.direcciones.length === 0) {
        this.cliente.direcciones = [];
        this.cliente.direcciones.push(new Direccion());
      } else {
        if (!this.cliente.direcciones[0].departamentoProvincia) {
          this.cliente.direcciones[0].departamentoProvincia = new OperationalDepartamento(1);
        }
        if (!this.cliente.direcciones[0].provincia) {
          this.cliente.direcciones[0].provincia = new OperationalProvincia(1);
        }
      }
      if (!this.cliente.telefonos || this.cliente.telefonos.length === 0) {
        this.cliente.telefonos = [];
        this.cliente.telefonos.push(new Telefono('', 1));
      } else {
        for (const telefono of this.cliente.telefonos) {
          switch (telefono.tipoTelefonoId) {
            case this.TelefonoCliente.staticParticular:
              telefono.icono = 'phone';
              break;
            case this.TelefonoCliente.staticCelular:
              telefono.icono = 'phone_android';
              break;
            case this.TelefonoCliente.staticLaboral:
              telefono.icono = 'phonelink_ring';
              break;
            default:
              telefono.icono = 'phone';
          }
        }
      }
      if (!this.cliente.emails || this.cliente.emails.length === 0) {
        this.cliente.emails = [];
        this.cliente.emails.push(new Email(1, '', false));
      } else {
        for (const email of this.cliente.emails) {
          switch (email.tipoEmailId) {
            case this.EmailCliente.staticPersonal:
              email.icono = 'contact_mail';
              break;
            case this.EmailCliente.staticLaboral:
              email.icono = 'email';
              break;
            default:
              email.icono = 'email';
          }
        }
      }
      if (!this.cliente.documentacionRespaldatoria) {
        this.cliente.documentacionRespaldatoria = [];
      }
    });
    this.getDocumentacionById();
  }

  agregarDireccion() {
    this.cliente.direcciones.push(new Direccion());
    this.selected.setValue(this.cliente.direcciones.length - 1);
  }

  eliminarDireccion() {
    this.cliente.direcciones.splice(this.selected.value, 1);
  }

  async getDocumentacionById() {
    this.documentacionRespaldatoria = await this.backendService
      .get(Documentacion, Cliente.path + Documentacion.path, null).toPromise();
    this.createDocumentosIfNotExists();
  }

  createDocumentosIfNotExists() {
    for (let i = 0; i < this.documentacionRespaldatoria.length; i ++) {
      if (this.documentacionRespaldatoria[i].documentos.length === 0) {
        this.documentacionRespaldatoria[i].documentos.push(new Documento(undefined));
      }
    }
  }

  back() {
    this.navigationService.back();
  }

  async confirmSave() {
   if (this.validateForm()) {
      this.dialogService.confirm(this.cliente.id ? 'Edición de cliente' : 'Alta de cliente',
      '¿Está seguro que desea guardar el cliente ' + this.cliente.name + ' ' + (this.cliente.lastname ? this.cliente.lastname : '') + '?')
      .then( res => {
        if (res) {
          this.saveCliente(res);
        }
      });
   }
  }

  validateForm() {
    let validationsOK = true;

    // Valida el resto de los controles con sus validadores
    if (!this.formValidatorService.isFormValid(this.clienteForm)
      || this.cliente.direcciones[0].pais.id === undefined) {
      validationsOK = false;
      this.validationFail = true;
    } else {
      validationsOK = true;
      this.validationFail = false;
    }
    if (this.checkEmailPrincipal()) {
      validationsOK = validationsOK && true;
    } else {
      this.emailPrincipalFail = true;
      validationsOK = false;
    }

    return validationsOK;
  }

  checkEmailPrincipal() {
    for (const email of this.cliente.emails){
      if (email.principal) {
        return true;
      }
    }
    return false;
  }

  async saveCliente(res) {
    if (res) {

      this.snackService.spinner(true);
      this.cliente.cuitCuil = this.cliente.cuitCuil.split('-').join('');

      if (this.cliente.id) { // Update
        try {
          await this.backendService.update(Cliente.path + this.cliente.id, this.cliente);
          this.saveLogos(this.cliente.id);
          this.snackService.success('Cliente editado satisfactoriamente');
          this.router.navigate(['/clientes/detalles/' + this.cliente.id]);
        } catch (ex) {
          if (ex[0]) {
            this.snackService.error(ex[0].details);
          } else if (ex.errors) {
            this.snackService.error(ex.errors[0].defaultMessage);
          } else {
            this.snackService.error(ex.message);
          }
        } finally {
          this.snackService.spinner(false);
        }
      } else {
        try {
          const response = await this.backendService.createWithResponse(Cliente.path, this.cliente);
          const clienteResponse = JSON.parse((response as Response).text());
          this.saveLogos(clienteResponse.id);
          this.router.navigate(['/clientes']);
          this.snackService.success('Cliente creado satisfactoriamente');
        } catch (ex) {
          if (ex[0]) {
            this.snackService.error(ex[0].details);
          } else if (ex.errors) {
            this.snackService.error(ex.errors[0].defaultMessage);
          } else {
            this.snackService.error(ex.message);
          }
        } finally {
          this.snackService.spinner(false);
        }
      }
    }
  }
  async saveLogos(clienteId) {
    try {
      let formdata: FormData;
      const archivos = this.cliente.logos;
      for (let i = 0; i < this.cliente.logos.length; i++) {
        if (archivos[i].id === undefined && archivos[i].file !== null && archivos[i].file !== undefined) {
          formdata = new FormData();
          formdata.append('file', archivos[i].file);
          formdata.append('name', archivos[i].name);
          formdata.append('id', clienteId);
          await this.backendService.createFile(Cliente.path + Logo.path, formdata);
        }
      }
    } catch (ex) {
      this.snackService.error(ex.message);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/cliente-add-edit/cliente-add-edit.component.ts